import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './style.css';

export default function ReferralSharingCopyLink(props) {
  const [copySuccess, setCopySuccess] = useState(false);

  const copyLinkToClipboard = (event) => {
    document.querySelector('#thisIsTheReferralLink').select();
    document.execCommand('copy');
    event.target.focus();
    setCopySuccess(true);
  };

  return (
    <>
      <Row>
        <Col>Use the link below to share your referral!</Col>
      </Row>
      <Row className='referralShareCopyLinkSpacing'>
        <Col>
          <input
            value={`https://bumpboxes.com/referred/${props.referralCode}`}
            aria-label={`https://bumpboxes.com/referred/${props.referralCode}`}
            id='thisIsTheReferralLink'
            readOnly
            className='referralShareCopyLinkURL'
          />
        </Col>
      </Row>
      <Row className='referralShareCopyLinkSpacing'>
        <Col>
          <Button
            id='getLinkForReferral'
            className='buttonMargin'
            size='large'
            onClick={copyLinkToClipboard}
          >
            {!copySuccess ? (
              'Copy Link'
            ) : (
              <span>
                <FontAwesomeIcon icon={faCheck} /> Copied To Clipboard!
              </span>
            )}
          </Button>
        </Col>
      </Row>
    </>
  );
}
